import { render, staticRenderFns } from "./designService.vue?vue&type=template&id=1bc19abe&scoped=true&"
import script from "./designService.vue?vue&type=script&lang=js&"
export * from "./designService.vue?vue&type=script&lang=js&"
import style0 from "./designService.vue?vue&type=style&index=0&id=1bc19abe&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc19abe",
  null
  
)

export default component.exports